// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pZJL","fullView":"styles_fullView__1sU7J"};